<template>
  <MainLayout activeIndex="2">
    <el-row type="flex" justify="center">
      <el-col :span="20">
        <UserProfile :user="user" />
        <el-card>
          <div slot="header">Reset Password</div>
          <el-form :model="form" status-icon :rules="rules" ref="form" label-width="180px">
            <el-form-item label="Old Password" prop="oldPassword">
              <el-input type="password" v-model.number="form.oldPassword"></el-input>
            </el-form-item>
            <el-form-item label="New Password" prop="newPassword">
              <el-input type="password" v-model="form.newPassword" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="Verify New Password" prop="checkPass">
              <el-input type="password" v-model="form.checkPass" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="submitForm('form')">Submit</el-button>
              <el-button @click="resetForm('form')">Cancel</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import UserProfile from "@/components/UserProfile.vue";
import { getUserById, resetPassword } from "@/api/users.js";

export default {
  name: "UserInfo",
  components: {
    MainLayout,
    UserProfile
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please Enter New Password."));
      } else {
        if (this.form.checkPass !== "") {
          this.$refs.form.validateField("checkPass");
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please Enter New Password Again"));
      } else if (value !== this.form.newPassword) {
        callback(new Error("The Passwords You Entered Do Not Match!"));
      } else {
        callback();
      }
    };
    return {
      user: {
        name: "",
        role: "",
        avatar: "",
        email: "",
        phone: ""
      },
      form: {
        oldPassword: "",
        newPassword: "",
        checkPass: ""
      },
      rules: {
        newPassword: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.getUserProfile();
  },
  methods: {
    getUserProfile() {
      getUserById(this.$route.params.id).then(res => {
        this.user = {
          name: res.full_name,
          avatar: res.avatar,
          email: res.email,
          phone: res.phone,
          role:
            res.power === "A"
              ? "Professor"
              : res.power === "B"
              ? "Assistant"
              : "Student"
        };
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          resetPassword(this.$store.state.userId, this.form.oldPassword, this.form.newPassword).then(res => {
            if (res.message === 'password set') {
              this.$message({
                type: "success",
                message: "New password set!"
              });
            } else {
              this.$message({
                type: "error",
                message: res.message
              })
            }
          });
        } else {
          this.$message({
            type: "error",
            message: "Form error occurred. Please check your inputs."
          })
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>